import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";

const initialEmployees = [
  {
    id: 1,
    name: "John Doe",
    department: "Sales",
    role: "Sales Executive",
    email: "john@example.com",
    phone: "9876543210",
    joinDate: "2023-05-14",
    salary: "35,000",
    status: "Active",
  },
  {
    id: 2,
    name: "Jane Smith",
    department: "Marketing",
    role: "Marketing Manager",
    email: "jane@example.com",
    phone: "9988776655",
    joinDate: "2022-11-22",
    salary: "55,000",
    status: "Active",
  },
  {
    id: 3,
    name: "Alice Johnson",
    department: "HR",
    role: "HR Executive",
    email: "alice@example.com",
    phone: "9998887777",
    joinDate: "2021-03-18",
    salary: "40,000",
    status: "On Leave",
  },
];

export default function Employees() {
  const [employees, setEmployees] = useState(initialEmployees);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [form, setForm] = useState({
    name: "",
    department: "",
    role: "",
    email: "",
    phone: "",
    joinDate: "",
    salary: "",
    status: "Active",
  });

  const filtered = employees.filter(emp =>
    Object.values(emp).some(value =>
      String(value).toLowerCase().includes(search.toLowerCase())
    )
  );

  const addEmployee = () => {
    setEmployees([
      ...employees,
      {
        id: employees.length + 1,
        ...form,
      },
    ]);
    setShowModal(false);
    setForm({
      name: "",
      department: "",
      role: "",
      email: "",
      phone: "",
      joinDate: "",
      salary: "",
      status: "Active",
    });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure?")) {
      setEmployees(employees.filter(e => e.id !== id));
    }
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">

        {/* TOP HEADER */}
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Employee Management</h1>

        {/* Controls */}
        <div className="flex flex-col md:flex-row justify-between mb-6 gap-3">
          <input
            type="text"
            placeholder="Search employees..."
            className="border border-gray-300 shadow-sm rounded-md p-2 w-full md:w-1/3"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Button
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
            onClick={() => setShowModal(true)}
          >
            + Add Employee
          </Button>
        </div>

        {/* Table */}
        <Card className="p-4 bg-white shadow-lg rounded-xl">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="p-3">Name</th>
                <th className="p-3">Department</th>
                <th className="p-3">Role</th>
                <th className="p-3">Email</th>
                <th className="p-3">Phone</th>
                <th className="p-3">Joining Date</th>
                <th className="p-3">Salary</th>
                <th className="p-3">Status</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map(emp => (
                <tr key={emp.id} className="border-b hover:bg-gray-100">
                  <td className="p-3 font-semibold">{emp.name}</td>
                  <td className="p-3">{emp.department}</td>
                  <td className="p-3">{emp.role}</td>
                  <td className="p-3">{emp.email}</td>
                  <td className="p-3">{emp.phone}</td>
                  <td className="p-3">{emp.joinDate}</td>
                  <td className="p-3">₹{emp.salary}</td>

                  {/* Status badge */}
                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        emp.status === "Active"
                          ? "bg-green-100 text-green-600"
                          : emp.status === "On Leave"
                          ? "bg-yellow-100 text-yellow-600"
                          : "bg-red-100 text-red-600"
                      }`}
                    >
                      {emp.status}
                    </span>
                  </td>

                  {/* Actions */}
                  <td className="p-3 flex gap-2">
                    <Button className="bg-yellow-500 px-3 py-1 text-white rounded-md">
                      Edit
                    </Button>
                    <Button
                      className="bg-red-500 px-3 py-1 text-white rounded-md"
                      onClick={() => handleDelete(emp.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        {/* Add Employee Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-xl w-full max-w-lg shadow-xl">
              <h2 className="text-xl font-bold mb-4">Add Employee</h2>

              <div className="grid grid-cols-2 gap-4">
                {Object.keys(form).map((key) => (
                  <input
                    key={key}
                    type={key === "joinDate" ? "date" : "text"}
                    placeholder={key.replace(/([A-Z])/g, " $1")}
                    className="border p-2 rounded-md"
                    value={form[key]}
                    onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                  />
                ))}
              </div>

              <div className="flex justify-end gap-3 mt-4">
                <Button
                  className="bg-gray-300 px-4 py-2 rounded-md"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="bg-blue-600 text-white px-4 py-2 rounded-md"
                  onClick={addEmployee}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </HrLayout>
  );
}
